import { PermissionType } from '@app/core/types/permission-type.type'
import { PermissionsSource } from '@core/types/permissions.source'

export const navigationReseller = [
  {
    title: 'NAV.CLIENTS',
    icon: 'people_outline',
    url: '/reseller/clients',
    permission: PermissionType.ClientSection,
  },
  {
    title: 'NAV.DEVICES',
    icon: 'devices_other',
    url: '/reseller/devices',
    permission: PermissionsSource.DEVICE,
  },
  {
    title: 'NAV.MY_TEAM',
    icon: 'people',
    url: '/reseller/my-team',
    permission: PermissionType.ResellerTeamSection,
  },
  {
    title: 'NAV.ALERTS',
    icon: 'warning',
    url: '/reseller/alerts',
    permission: PermissionsSource.ALERTS,
  },
  {
    title: 'NAV.CONFIGURATION',
    icon: 'settings',
    url: '/reseller/config',
    permission: PermissionsSource.CONFIGURATION,
  },
]
